
import { Component, Inject, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import { AuthStore } from "../../../../../common/src/stores/AuthStore";
import { OrganizationStore } from "../../../stores/organization/OrganizationStore";
import LoadingOverlay from "../../../../../common/src/components/LoadingOverlay.vue";
import { OrganizationItem } from "@gsx/common/src/types/http/dashboard/organization";
import { UserEditFavoriteStore } from "../../../stores/user/UserEditFavoriteStore";
import { isAdmin } from "@gsx/common";
import { LMap, LMarker, LTileLayer } from "vue2-leaflet";
import { QuiltyResourcesListStore } from "../../../stores/quiltyResources/QuiltyResourcesListStore";
import BedrockOrgResearch from "./BedrockOrgResearch.vue";

@Component({
    components: {
        BedrockOrgResearch,
        LoadingOverlay,
        LMap,
        LMarker,
        LTileLayer,
    },
})
export default class OrganizationHeader extends Vue {
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    organizationStore: OrganizationStore = this.container.get(OrganizationStore);
    userEditFavoriteStore: UserEditFavoriteStore = this.container.get(UserEditFavoriteStore);
    readonly quiltyResourcesListStore: QuiltyResourcesListStore =
        this.container.get(QuiltyResourcesListStore);

    mounted() {
        this.authStore.me();
    }

    get organizationId(): string {
        return this.$route.params.organization;
    }

    get organization(): OrganizationItem | null {
        return this.organizationStore.item;
    }

    get quiltyResources() {
        return this.quiltyResourcesListStore.items || [];
    }

    get isOrganizationFavorite() {
        return this.authStore.user?.favorites?.organizationIds?.includes(this.organizationId);
    }

    get isQuiltyVerified() {
        return (
            this.organization &&
            ((this.organization.keyPerformanceIndicators &&
                this.organization.keyPerformanceIndicators.yearlyFinancialData &&
                this.organization.keyPerformanceIndicators.yearlyFinancialData.length) ||
                this.organization.reports.length ||
                (this.organization.investments && this.organization.investments.length) ||
                (this.organization.mergerAcquisitions &&
                    this.organization.mergerAcquisitions.length) ||
                this.quiltyResources.length)
        );
    }

    get updateOrganizationButtonText(): string | null {
        const user = this.authStore.user;
        const organization = this.organization;

        return user?.organization?.organizationid === organization?.organizationid
            ? "Update Organization Profile"
            : "Request Affiliation and Update Profile";
    }

    get updateOrganizationUrl(): string | null {
        const user = this.authStore.user;
        const organization = this.organization;

        if (!organization) {
            return null;
        }

        if (!user) {
            return "/signin";
        }

        if (isAdmin(user)) {
            return `/admin/organizations/${organization.organizationid}`;
        }

        if (!user.organization) {
            return "/member/request-affiliation";
        }

        if (user.organization.organizationid === organization.organizationid) {
            return "/member/organization/profile";
        }

        // Do not display button if user is affiliated with a different organization
        return null;
    }

    organizationUrl(organizationId: string) {
        return `/dashboard/organizations/${organizationId}`;
    }

    toggleFavorites() {
        if (this.isOrganizationFavorite) {
            const indexOf =
                this.authStore.user!.favorites!.organizationIds?.indexOf(this.organizationId) ?? -1;
            if (indexOf >= 0) {
                this.authStore.user?.favorites?.organizationIds?.splice(indexOf, 1);
            }
            this.userEditFavoriteStore.removeOrganization(this.organizationId);
        } else {
            this.authStore.user?.favorites?.organizationIds?.push(this.organizationId);
            this.userEditFavoriteStore.addOrganization(this.organizationId);
        }
    }
}
